import { render, staticRenderFns } from "./PieceOnEarth.vue?vue&type=template&id=ea90b23c&scoped=true&"
import script from "./PieceOnEarth.vue?vue&type=script&lang=js&"
export * from "./PieceOnEarth.vue?vue&type=script&lang=js&"
import style0 from "./PieceOnEarth.vue?vue&type=style&index=0&id=ea90b23c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea90b23c",
  null
  
)

export default component.exports